module.exports = __webpack_public_path__ + "img/speed_test.f1b5284.svg";